import { extendObservable } from 'mobx';

class HeaderState {
  constructor(props) {
    extendObservable(this, {
      drawerOpen: false,
      navOptions: props.nav_options || 'default',
      hideLeadLinks: props.hide_lead_links || false,
    });
  }

  toggleDrawer = () => {
    this.drawerOpen = !this.drawerOpen;
  };
}

export default HeaderState;
